// @ts-check
import { useMutation } from '@tanstack/react-query';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useSupportRequestAuthenticate = () => {
	const snackbarError = useSnackbarError('Error authenticating');

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/support/request/index.raw').LWApiPublicSupportRequestAuthenticateParamsRawI} params */
			(params) => api.support.request.apiRaw.authenticate(params),

		onError: snackbarError,
	});
};

export default useSupportRequestAuthenticate;
